
import { appConst, Component, FormPageMixins, Mixins, PageResultModalMixins } from "@/lib";
import Income from "@/store/modules/foreignexchangecollection/income/entity"
import IncomeDetail from "@/store/modules/foreignexchangecollection/incomedetail/entity"
import moment from "moment"

import CardTitleView from "@/components/card-title/index.vue"
import IncomeDetailModal from "./income-detail.vue"

@Component({components: {CardTitleView, IncomeDetailModal}})
export default class DetailView extends Mixins(FormPageMixins, PageResultModalMixins) {
  model = new Income();
  loading = false;

  get record() {
    return this.$store.state.foreignexchangecollection.income.editIncome as Income;
  }

  get businessGroup() {
    return this.getCodeDescription(appConst.codeCategory.businessGroup, this.model.businessGroup)
  }

  get currency() {
    return this.getCodeDescription(appConst.codeCategory.currency, this.model.currency)
  }

  // 逾期天数：当前日期超过应付款日的天数。若未到期，则显示【未逾期】，否则显示逾期天数（比如：1天），同时颜色为红色
  get prePaymentDays() {
    const notExpiredText = this.getCodeDescription(appConst.codeCategory.incomeStatus, appConst.incomeStatus.notExpired);
    const dayText = this.L('app.Income.Day');
    let currentDate = this.$util.format.date(Date.now());
    if (!!this.model.prePaymentDate && this.$util.format.date(this.model.prePaymentDate) < currentDate) {
      let days = moment(currentDate).diff(moment(this.model.prePaymentDate), 'days');
      return {text: `${days}${dayText}`, days: days};
    }
    return {text: notExpiredText, days: 0};
  }
  get restDays() {
    const notExpiredText = this.getCodeDescription(appConst.codeCategory.incomeStatus, appConst.incomeStatus.notExpired);
    const dayText = this.L('app.Income.Day');
    let currentDate = this.$util.format.date(Date.now());
    if (!!this.model.restDate && this.$util.format.date(this.model.restDate) < currentDate) {
      let days = moment(currentDate).diff(moment(this.model.restDate), 'days');
      return {text: `${days}${dayText}`, days: days};
    }
    return {text: notExpiredText, days: 0};
  }
  // 收款类型
  get incomeTypeList() {
    return this.getCodeListByCategory(appConst.codeCategory.incomeType)
  }

  get column() {
    let list = [
      this.$util.render.baseColumn("app.SystemCode.SequenceNo", 100, {type: "index", align: 'center'}),
      
      this.$util.render.baseColumn("app.IncomeDetail.Amount", null, {key: "amount", minWidth: 100, maxWidth: 150, render: (h: any, params: any) => {
        return [h("span", this.$util.format.amount(params.row.amount))];
      }}),
      this.$util.render.baseColumn("app.IncomeDetail.BankFee", null, {key: "bankFee", minWidth: 100, maxWidth: 150, render: (h: any, params: any) => {
        return [h("span", this.$util.format.amount(params.row.bankFee))];
      }}),
      this.$util.render.dateColumn("app.IncomeDetail.IncomeDate", "incomeDate"),
      this.$util.render.baseColumn("app.IncomeDetail.Remark", null, {key: "remark", minWidth: 100}),
      this.$util.render.baseColumn("Action.Actions", null, {key: "actions", slot: "actions", width: 100, fixed: 'right'})
    ];
    if (this.model.isAdvance) {
      list.splice(1, 0, this.$util.render.codeColumn("app.IncomeDetail.IncomeType", "incomeType", () => { return this.incomeTypeList }, {minWidth: 120}))
    }
    return list;
  }

  created() {
    Object.assign(this.config,{
      labelWidth: 80,
      isRedirectIndex: true,
      getAction: "foreignexchangecollection/income/getByDeclareCustomsId",
      isHideOk: true
    })
  }

  /**
   * 预付款修改
   */
  prePaymentAmountChange() {
    this.model.restAmount = Number.parseFloat((this.model.receiverAmount - this.model.prePaymentAmount).toFixed(2));
  }

  /**
   * 查看
   */
  handleDetail(index) {
    let detailData = {
      editRowIndex: index,
      incomeType: this.model.incomeDetailList[index].incomeType,
      amount: this.model.incomeDetailList[index].amount,
      bankFee: this.model.incomeDetailList[index].bankFee,
      currency: this.model.currency,
      currency_en: this.model.currency_en,
      incomeDate: this.model.incomeDetailList[index].incomeDate,
      remark: this.model.incomeDetailList[index].remark,
      prePaymentAmount: this.model.prePaymentAmount,
      restAmount: this.model.restAmount,
      isAdvance: this.model.isAdvance,
    }
    this.$store.commit("foreignexchangecollection/income/editDetail", detailData);
    this.open("income-detail-modal");
  }
}
